"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get API_TOKEN_KEY_TYPES () {
        return API_TOKEN_KEY_TYPES;
    },
    get ApiTokenModel () {
        return ApiTokenModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const API_TOKEN_KEY_TYPES = [
    "standard",
    "partner"
];
const ApiTokenModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    last_used_at: _zod.z.date().or(_zod.z.null()),
    deleted_at: _zod.z.date().or(_zod.z.null()),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    api_token_id: _zod.z.string(),
    enabled: _zod.z.boolean().optional(),
    /**
	 * Track if this was disabled as part of a system change so that in can be undone later
	 */ disabled_by_system: _zod.z.boolean().optional(),
    /** Absent means "standard" — existing tokens predate this field; read as `key_type ?? "standard"`. */ key_type: _zod.z.enum(API_TOKEN_KEY_TYPES).optional()
});
